import { useState } from "react";
import {
  Avatar,
  Menu,
} from "@mui/material";

import { LogoutButton } from "./LogoutButton";
import { ProfileAvatar } from "./ProfileAvatar";
import { useUser } from "hooks/useAuth";

const AccountPopover = () => {
  
  const { user: { name } } = useUser();

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <Avatar
        onClick={handleOpen}
        alt={name}
        sx={{
          height: 32,
          width: 32,
          cursor: "pointer"
        }}
      />
      <Menu
        MenuListProps={{ disablePadding: true }}
        open={openMenu}
        onClose={handleClose}
        anchorEl={anchorEl}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        PaperProps={{
          sx: {
            width: 360,
            padding: 0
          }
        }}
      >
        <ProfileAvatar {...{ handleClose }} />
        <LogoutButton {...{ handleClose }} />
      </Menu>
    </>
  );

}

export default AccountPopover;
